import { ShieldOff, LogOut } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { signOut } from '../lib/auth';

export function AccessDenied({ email }) {
  const handleLogout = async () => {
    await signOut();
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24,
    }}>
      <div className="card" style={{ width: '100%', maxWidth: 460, padding: '36px 32px', textAlign: 'center' }}>
        <div style={{
          width: 64, height: 64, borderRadius: 999, background: 'var(--danger-soft)',
          color: 'var(--danger)', display: 'inline-flex', alignItems: 'center',
          justifyContent: 'center', marginBottom: 16,
        }}>
          <ShieldOff size={28} strokeWidth={2.2} />
        </div>
        <h1 className="font-display" style={{ fontSize: 22, fontWeight: 600, margin: '0 0 8px' }}>
          Sem acesso ao Faturamento
        </h1>
        <p style={{ fontSize: 13.5, color: 'var(--muted)', lineHeight: 1.5, margin: '0 0 22px' }}>
          {email && <>Você está logado como <strong>{email}</strong>, mas seu usuário não tem acesso liberado a este app.<br /></>}
          Peça ao administrador pra ir em <strong>admin.finetus</strong> e marcar acesso ao app <strong>Faturamento</strong>.
        </p>
        <Button variant="secondary" icon={LogOut} onClick={handleLogout}
          style={{ justifyContent: 'center' }}>
          Sair
        </Button>
      </div>
    </div>
  );
}
